import Typography from "@mui/material/Typography"
import { alpha, styled } from "@mui/material/styles"

import Row from "../../../common/components/Row"

/** Pill styles shared by the sidebar links and the profile menu button. */
export const shouldForwardProp = {
  shouldForwardProp: (prop) => prop !== "extended",
}

export const CommonLink = styled(Row, {
  shouldForwardProp: (prop) => ["extended", "isActive"].indexOf(prop) === -1,
})(({ theme, extended, isActive }) => ({
  justifyContent: extended ? "flex-start" : "center",
  alignItems: "center",
  padding: theme.spacing(1.5),
  gap: theme.spacing(1.5),
  width: "100%",
  height: "42px",
  flexShrink: 0,
  backgroundColor: isActive
    ? alpha(theme.palette.secondary.light, 0.9)
    : "inherit",
  boxShadow: isActive ? "rgba(0, 0, 0, 0.24) 0px 3px 8px" : "none",
  backdropFilter: isActive ? "blur(21px)" : "none",
  WebkitBackdropFilter: isActive ? "blur(21px)" : "none",
  textDecoration: "none",
  border: isActive ? "1px solid rgba(255, 255, 255, 0.25)" : "none",
  "&:hover": {
    backgroundColor: isActive
      ? theme.palette.secondary.light
      : alpha(theme.palette.secondary.light, 0.6),
  },
}))

export const LinkContainer = styled(
  CommonLink,
  shouldForwardProp
)(({ theme, extended }) => ({
  borderRadius: "24px",
}))

export const AvatarButton = styled(
  CommonLink,
  shouldForwardProp
)(({ theme, extended }) => ({
  background:
    "linear-gradient(159deg, rgba(137, 47, 206, 1) 3%, rgba(137, 47, 206, 0.8) 100%)",
  backdropFilter: "blur(21px)",
  border: `1px solid rgba(255, 255, 255, 0.15)`,
  boxShadow: "0 28px 90px 0 rgba(0, 0, 0, 0.7)",
  borderRadius: "32px",
  cursor: "pointer",
  height: "50px",
  font: "inherit",
  color: "inherit",
  textAlign: "left",
}))

export const LinkTypography = styled(
  (props) => <Typography variant="h6" {...props} />,
  shouldForwardProp
)(({ theme, extended }) => ({
  color: "white",
  textShadow: "1px 2px 10px rgba(0, 0, 0, 0.2)",
  textWrap: "nowrap",
  display: extended ? "inline-flex" : "none",
}))
